import { IDBPObjectStore, openDB } from 'idb';
import { IDBPDatabase } from 'idb/build/entry';

export class IDB {
  protected db: IDBPDatabase | undefined;
  private messagesAdded = new Set<string>();

  constructor(public name: string) {}

  async create(): Promise<IDBPDatabase<unknown>> {
    const name = this.name;
    const setupIndexes = this.setupIndexes;
    this.db = await openDB(`netbroker_${name}`, 1, {
      upgrade(db) {
        const store = db.createObjectStore(`store`, { keyPath: 'id' });
        setupIndexes(store);
      },
    });
    return this.db;
  }

  setupIndexes(_store: IDBPObjectStore<any, any, `store`, 'versionchange'>) {}

  log(message: { id: string }) {
    if (!this.db) {
      throw new Error('Database not initialized');
    }
    if (this.messagesAdded.has(message.id)) {
      // message already saved
      return;
    } else {
      if (this.messagesAdded.size > 10000) {
        this.messagesAdded.clear();
      }

      this.messagesAdded.add(message.id);
    }

    this.db.add(`store`, message).catch(err => {
      console.error(`Failed to store`, err, message);
    });
  }

  async delete() {
    if (!this.db) {
      throw new Error('Database not initialized');
    }

    try {
      await this.db.clear(`store`);
    } catch (err) {
      console.error(`Failed to clear`, err);
    }
  }

  async findAll() {
    if (!this.db) {
      throw new Error('Database not initialized');
    }

    return this.db.getAll(`store`);
  }
}
